import SecureLS from "secure-ls";

export const ls = new SecureLS({
  encodingType: "rc4",
  isCompression: false,
  encryptionSecret: "Zs%Ma??5Qn,!ZB#_nhM"
});

export const isJSON = (value) => {
  try { 
    JSON.parse(value); 
    
    return true; 
  } catch (e) { 
    return false; 
  }
}

export const paymentMethodDisplayMinSpendValue = (type) => {
  let min_spend = 0;
  if (type.includes('PAYMONGO')) min_spend = 100;
  else if (type === 'CC_XENDIT') min_spend = 20;
  else if (type.includes('XENDIT')) min_spend = 1;
  return min_spend;
};

export const paymentMethodDisplayMaxSpendValue = (type) => {
  if (type === "PAYMAYA_XENDIT" || type === "UNIONBANK_XENDIT") return 100000;
  return 50000;
};

export const paymentMethodDisplayLabel = (type) => {
  let display_text = "";
  if (type === "COD") display_text = "Cash on Delivery";
  else if (type.includes('CC')) display_text = "Local Debit/Credit Cards";
  else if (type.includes('GRAB_PAY')) display_text = "GrabPay";
  else if (type.includes('GCASH')) display_text = "GCash";
  else if (type.includes('PAYMAYA')) display_text = "Maya";
  else if (type.includes('SHOPEEPAY')) display_text = "ShopeePay";
  else if (type.includes('QRPH')) display_text = "QR Ph";
  else if (type.includes('UNIONBANK')) display_text = "UnionBank - Direct Debit"
  return display_text;
};

export const paymentMethodDisplayIcon = (type) => {
  let img = null;
  if (type === "COD") img = require('@/assets/images/ic-cod.svg');
  else if (type.includes('CC')) img = require('@/assets/images/credit-card-visa-master.png');
  else if (type.includes('GRAB_PAY')) img = require('@/assets/images/ic-grabpay.png');
  else if (type.includes('GCASH')) img = require('@/assets/images/ic-gcash.png');
  else if (type.includes('PAYMAYA')) img = require('@/assets/images/ic-maya.png');
  else if (type.includes('SHOPEEPAY')) img = require('@/assets/images/ic-shopeepay.png');
  else if (type.includes('QRPH')) img = require('@/assets/images/ic-qr-ph.png');
  else if (type.includes('UNIONBANK')) img = require('@/assets/images/ic-unionbank.png');
  return img;
};

export const hexToRgba = (hex, alpha) =>
  `rgba(${parseInt(hex.slice(1, 3), 16)}, ${parseInt(hex.slice(3, 5), 16)}, ${parseInt(
    hex.slice(5, 7),
    16
  )}, ${alpha})`;

export const thousandsSeparator = (value) => new Intl.NumberFormat('en-US').format(value);

export const reverseThousands = (value) => Number(value.replaceAll(',', ''));

export const hasCookie = (cookieName) => {
  const cookies = document.cookie.split(';');

  return cookies.map((cookie) => {
    const [key] = cookie.trim().split('=');
    return key;
  }).includes(cookieName);
};

export const setSsoUserCookie = (data = {}, key = 'sso_user') => {
    const cookieKey = typeof key === 'string' ? key : 'sso_user';
    const existing = getSsoUserCookie(cookieKey);
    const merged = { ...existing, ...data };

    document.cookie = `${cookieKey}=${JSON.stringify(merged)}; path=/`;
};

export const getSsoUserCookie = (key = 'sso_user') => {
  const cookieKey = typeof key === 'string' ? key : 'sso_user';
  const ssoUserCookie = document.cookie.split(`${cookieKey}=`).pop()?.split(';')[0];
  if (hasCookie(cookieKey)) {
    try {
      return JSON.parse(ssoUserCookie);
    } catch {
      return {};
    }
  }

  return {};
};

export const removeSsoUserCookie = (key = 'sso_user') => {
  const cookieKey = typeof key === 'string' ? key : 'sso_user';
  const cookie = {};
  document.cookie = `${cookieKey}=${JSON.stringify(cookie)}; path=/`;
};

export const getInitials = ({ first_name, last_name }) => {
  const firstInitial = first_name.charAt(0);
  const lastInitial = last_name.charAt(0);
  return (firstInitial + lastInitial).toUpperCase();
};

export const getMaskedName = ({ first_name = '', last_name = '' } = {}) => {
  const maskPart = (name) => {
    if (!name || typeof name !== 'string') return '';
    return name
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => {
        if (part.length >= 4) {
          return `${part[0]}•••`;
        }
        return `${part[0]}${'•'.repeat(part.length - 1)}`;
      })
      .join(' ');
  };

  const maskedFirst = maskPart(first_name);
  const maskedLast = maskPart(last_name);

  return [maskedFirst, maskedLast].filter(Boolean).join(' ');
};

export const getMaskedEmail = (email = '') => {
  if (!email || typeof email !== 'string') return '';

  const [localPart, domainPart] = email.trim().split('@');
  if (!domainPart) return email;

  const maskedLocal = localPart.length <= 1
    ? localPart
    : `${localPart[0]}${'•'.repeat(Math.min(localPart.length, 6) - 1)}`;

  return `${maskedLocal}@${domainPart}`;
};

export const getMaskedMobile = (mobile = '') => {
  if (!mobile || typeof mobile !== 'string') return '';

  // Remove spaces or non-digit/non-plus characters
  const cleaned = mobile.trim().replace(/[^\d+]/g, '');

  let countryCode = '+63';
  let digits = cleaned;

  if (cleaned.startsWith('+63')) {
    countryCode = '+63';
    digits = cleaned.slice(3);
  } else if (cleaned.startsWith('63') && cleaned.length === 12) {
    countryCode = '+63';
    digits = cleaned.slice(2);
  } else if (cleaned.startsWith('0') && cleaned.length === 11) {
    countryCode = '+63';
    digits = cleaned.slice(1);
  }

  if (digits.length === 10) {
    const firstDigit = digits[0];
    const lastTwoDigits = digits.slice(-2);
    return `${countryCode} ${firstDigit}•• ••• ••${lastTwoDigits}`;
  }

  // Fallback for non-standard lengths
  if (digits.length > 3) {
    const first = digits[0];
    const last = digits.slice(-2);
    const maskedMiddle = '*'.repeat(digits.length - 3);
    return `${countryCode} ${first}${maskedMiddle}${last}`;
  }

  return mobile;
};
